import { Link } from "react-router-dom";

const domaines = [
  {
    name: "Toitures-terrasses",
    tag: "Cœur de métier",
    description: "Membranes bitumineuses, EPDM, étanchéité liquide — notre spécialité principale sur tous types de toitures-terrasses.",
    image: "https://readdy.ai/api/search-image?query=dramatic%20aerial%20wide%20angle%20view%20of%20large%20flat%20commercial%20rooftop%20with%20perfectly%20applied%20black%20bituminous%20waterproofing%20membrane%2C%20crisp%20clean%20lines%2C%20urban%20skyline%20in%20background%2C%20golden%20hour%20light%2C%20professional%20architectural%20photography%2C%20stunning%20roofing%20project%2C%20sharp%20details&width=1200&height=600&seq=ksbtp-sector-v2-001&orientation=landscape",
    featured: true,
    href: "/services/toitures-terrasses",
  },
  {
    name: "Parkings",
    tag: "Enrobés & asphalte",
    description: "Étanchéité de parkings en enrobé coulé à froid, asphalte gravillonné et résines époxy pour surfaces carrossables.",
    image: "https://readdy.ai/api/search-image?query=modern%20underground%20parking%20garage%20with%20smooth%20freshly%20applied%20dark%20grey%20epoxy%20resin%20floor%20coating%2C%20bright%20LED%20lighting%20reflecting%20on%20glossy%20surface%2C%20clean%20geometric%20lines%2C%20professional%20industrial%20photography%2C%20impressive%20scale&width=600&height=400&seq=ksbtp-sector-v2-002&orientation=landscape",
    featured: false,
    href: "/services/parkings",
  },
  {
    name: "Dalles carrossables",
    tag: "Surfaces lourdes",
    description: "Protection et étanchéité de dalles soumises au trafic lourd : résines, asphalte coulé, membranes haute résistance.",
    image: "https://readdy.ai/api/search-image?query=wide%20concrete%20carrossable%20slab%20with%20freshly%20applied%20thick%20protective%20waterproof%20coating%2C%20heavy%20duty%20surface%20treatment%2C%20construction%20site%20with%20machinery%2C%20dramatic%20perspective%2C%20professional%20BTP%20photography%2C%20strong%20industrial%20aesthetic&width=600&height=400&seq=ksbtp-sector-v2-003&orientation=landscape",
    featured: false,
    href: "/services/dalles-carrossables",
  },
  {
    name: "Terrasses",
    tag: "Résidentiel & tertiaire",
    description: "Étanchéité de terrasses accessibles ou inaccessibles, avec finitions carrelées, gravillonnées ou végétalisées.",
    image: "https://readdy.ai/api/search-image?query=beautiful%20modern%20rooftop%20terrace%20with%20pristine%20waterproofed%20surface%2C%20elegant%20stone%20tiles%2C%20city%20view%20panorama%2C%20blue%20sky%2C%20contemporary%20architecture%2C%20luxury%20residential%20building%2C%20professional%20real%20estate%20photography%2C%20stunning%20finish&width=600&height=400&seq=ksbtp-sector-v2-004&orientation=landscape",
    featured: false,
    href: "/services/terrasses",
  },
  {
    name: "Étanchéité + isolation thermique",
    tag: "Sur béton",
    description: "Complexes d'étanchéité avec isolation thermique intégrée sur support béton : sarking, ITE, toiture froide ou chaude.",
    image: "https://readdy.ai/api/search-image?query=cross%20section%20view%20of%20modern%20roofing%20insulation%20system%20with%20white%20rigid%20foam%20panels%20being%20installed%20under%20waterproof%20membrane%20on%20concrete%20roof%2C%20clean%20technical%20installation%2C%20bright%20daylight%2C%20professional%20construction%20photography%2C%20precise%20layered%20system&width=600&height=400&seq=ksbtp-sector-v2-005&orientation=landscape",
    featured: false,
    href: "/services/etancheite-isolation",
  },
];

export default function SectorsSection() {
  const featured = domaines[0];
  const others = domaines.slice(1);

  return (
    <section id="metiers" className="py-12 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#00a340] mb-2">Nos expertises</span>
          <h2 className="text-2xl md:text-5xl font-extrabold text-gray-900 mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Nos domaines{" "}
            <span className="italic text-[#00a340] underline decoration-[#4cd97a] underline-offset-4">
              d&apos;étanchéité
            </span>
          </h2>
          <p className="text-gray-500 text-sm md:text-lg max-w-xl mx-auto">
            Du diagnostic à la livraison, nous intervenons sur tous types d&apos;ouvrages avec des solutions durables et adaptées
          </p>
        </div>

        {/* Featured card */}
        <Link
          to={featured.href}
          className="relative rounded-2xl overflow-hidden mb-3 md:mb-4 group cursor-pointer block"
          style={{ height: "340px" }}
        >
          <img
            src={featured.image}
            alt={featured.name}
            className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent"></div>
          <div className="absolute inset-0 bg-[#00a340]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <div className="absolute bottom-0 left-0 p-5 md:p-10 max-w-lg">
            <span className="inline-block px-3 py-1 rounded-full bg-[#00a340] text-white text-xs font-bold uppercase tracking-wider mb-3">
              {featured.tag}
            </span>
            <h3 className="text-2xl md:text-4xl font-extrabold text-white mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {featured.name}
            </h3>
            <p className="text-green-100 text-sm leading-relaxed hidden sm:block max-w-sm">{featured.description}</p>
            <span className="inline-flex items-center gap-1.5 mt-3 text-[#4cd97a] text-xs font-semibold group-hover:gap-2.5 transition-all">
              En savoir plus <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </Link>

        {/* Other 4 cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {others.map((d) => (
            <Link
              key={d.name}
              to={d.href}
              className="relative rounded-2xl overflow-hidden cursor-pointer group block"
              style={{ height: "200px" }}
            >
              <img
                src={d.image}
                alt={d.name}
                className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 bg-[#00a340]/15 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <span className="block text-[9px] md:text-[10px] font-bold uppercase tracking-widest text-[#4cd97a] mb-0.5">{d.tag}</span>
                <span className="text-white font-bold text-xs md:text-sm leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  {d.name}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
